import {ThemeProvider, Container, Box, Typography, CardContent} from '@mui/material';

import theme from "../../theme";

import { motion } from 'framer-motion';

const fadeInVariant = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' },
    delay: 0.8,
  },
};

const Colaboration = () => {

    
    return(

        <ThemeProvider theme={theme}>
            <Container maxWidth="lg"
                       id='colaboration'
                       sx={{
                           backgroundColor:'transparent',
                           mt:{ xs: 1, md: 10, lg: '20px' },
                           maxHeight:'300px',
                           mb:{ xs: 1, md: 10, lg: '20px' }
                       }}>
                <Box>

                    <motion.div
                        variants={fadeInVariant}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        >
                    <CardContent sx={{
                        display:'flex',
                        flexDirection:'column',
                        alignItems:' center'
                    }}>
                        <Typography variant="body2"
                                    sx={{
                                        marginTop: { xs: '20px', md: '10px',lg:'10px', xl:'1px' },
                                        fontSize: { xs: 20, md: 30, xl:30 },
                                        fontWeight: 700,
                                        fontFamily: 'Caveat',
                                        textAlign:'center',
                                        
                                    }}>
                           Jesteś sadownikiem lub rolnikiem z uprawami kwitnącymi? <br/>
                            Chcesz mieć większe plony?<br/>
                            Skontaktuj się z naszą pasieką wędrowną. <br/>
                            Wypełnij formularz kontaktowy lub zadzwoń!
                        </Typography>
                    </CardContent>
                   </motion.div>                     
                </Box>
            </Container >
        </ThemeProvider >
    )
}

export default Colaboration;